<template>
  <Badge
    v-if="
      !isMpScope &&
      (props.displayUnsupported ||
        compositionMode !== CompositionMode.UNSUPPORTED)
    "
    :class="currentSettings.bgClass"
  >
    <Icon :icon="currentSettings.icon" />
    {{ $t(currentSettings.name) }}
  </Badge>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { CompositionMode } from '@spreadgroup/common-partner-lib/composition';
import Badge from '../../badge/Badge.vue';
import { compositionModeSettings } from 'commons/composition/compositionHelper';
import { usePublishingStore } from 'commons/stores/publishing';

const props = defineProps<{
  compositionMode: CompositionMode;
  displayUnsupported?: boolean;
}>();

const publishingStore = usePublishingStore();
const isMpScope = computed(() => publishingStore.isMpScope);

const currentSettings = computed(
  () => compositionModeSettings[props.compositionMode],
);
</script>

<style lang="scss" scoped>
@import 'src/scss/styleguide/colors';

.badge {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
